import { FilterResults, PostFilterBody, screener } from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

import { hasEmptyEntityTagValues } from './utils';

export const fetchFilteredEntitiesTagsOnly = (
  filters: PostFilterBody,
  isApiScreenerEntitiesV3FlagEnabled: boolean,
  signal?: AbortSignal
) =>
  wretchRequest<FilterResults>(
    isApiScreenerEntitiesV3FlagEnabled
      ? screener.postFilterv3.path
      : screener.postFilter.path,
    {
      method: 'post',
      body: {
        filters,
        tags_only: true,
      },
      signal,
    }
  );

export const fetchFilteredEntities = (
  filters: PostFilterBody,
  isApiScreenerEntitiesV3FlagEnabled: boolean,
  signal?: AbortSignal
) => {
  if (hasEmptyEntityTagValues(filters)) {
    return Promise.resolve({
      entities: [],
      data: [],
      page: {
        current: 0,
        size: 0,
        next: undefined,
      },
      total_count: 0,
    });
  }

  const postFilterPath = isApiScreenerEntitiesV3FlagEnabled
    ? screener.postFilterv3.path
    : screener.postFilter.path;
  return wretchRequest<FilterResults>(postFilterPath, {
    method: 'post',
    body: {
      filters,
      tags_only: false,
    },
    signal,
  });
};
